module.exports = __webpack_public_path__ + "static/media/finance-feature-3.9b5579b1.svg";